import React from 'react';

function StudentDashboard() {
    return (
        <div className='StudentDashboard'>
            <h1>Student Dashboard</h1>
            <p>Welcome, student! This is your dashboard.</p>
        </div>
    );
}

export default StudentDashboard;
